import React, {useState, useEffect} from 'react';
import { Button,NumberBox, } from 'devextreme-react';
import './yaklasikhesap.css'


const YaklasikHesap = () => {

    const listeBasligi = "Arge Hesaplama";

    const [popupState, setPopupState] = useState(false);
    const [yeniTutar, setYeniTutar] = useState();
    const [data, setData] = useState({
        spek1: 0, spek2: 0, spekOran1: 21.749999, spekOran2: 21.750000110635,
        tahakkukTutar1: 0, tahakkukTutar2: 0, tahakkukOran1: 35.6321827174799, tahakkukOran2: 35.6321801661318,
        indirimTutar1: 0, indirimTutar2: 0, indirimOran1: 64.5161623730653, indirimOran2: 64.5161449962351,
        spekIndirim1: 0, spekIndirim2: 0,
        sonuc: 0, sonucToplamAylik:0, sonucToplamAylik10:0,  sonucToplamAylik15:0, sonucToplamAylik20:0, sonucToplamAylik25:0,
        ilaveTutar:null
    })


    const ekle = (temizle) => {
        let spek1 = data.spek1 + data.ilaveTutar;
        if (temizle) {
            spek1 = 0;
        }
        let tahakkukTutar1 = spek1 / 100 * data.spekOran1;
        let indirimTutar1 = tahakkukTutar1 / 100 * data.tahakkukOran1;
        let spekIndirim1 = indirimTutar1 / 100 * data.indirimOran1;
        let spek2 = spek1 * 0.848454;
        let tahakkukTutar2 = spek2 / 100 * data.spekOran2;
        let indirimTutar2 = tahakkukTutar2 / 100 * data.tahakkukOran2;
        let spekIndirim2 = indirimTutar2 / 100 * data.indirimOran2;
        let sonuc = tahakkukTutar1 - tahakkukTutar2;
        let sonucToplamAylik = sonuc * 74;
        let sonucToplamAylik20 = sonucToplamAylik /100 * 20;


        setData(Object.assign({}, data,
            {
                spek1: spek1,
                tahakkukTutar1: tahakkukTutar1,
                indirimTutar1: indirimTutar1,
                spekIndirim1: spekIndirim1,
                spek2: spek2,
                tahakkukTutar2: tahakkukTutar2,
                indirimTutar2: indirimTutar2,
                spekIndirim2: spekIndirim2,
                sonuc: sonuc,
                sonucToplamAylik : sonucToplamAylik,
                ilaveTutar:null,
                sonucToplamAylik20:sonucToplamAylik20
            }));
        popupClose();

    }

    const eklePopup = () => {
        setPopupState(true);

    }

    const popupClose = () => {
        setPopupState(false);
    }

    const format = (value) => {

        var currency_symbol = "₺";
        var formattedOutput = new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 2,
        });
        return formattedOutput.format(value).replace(currency_symbol, '')
        // return value.toFixed(2);
    }

    return <>


        <h2 className={'dx-icon-product'} >{listeBasligi}</h2>
        <div className="dx-field">
            <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                <Button key="yenile" className={"ml-1 bg-success text-white"}
                        onClick={() => ekle(true)}>Sıfırla</Button>,
                <Button key="ekle" onClick={eklePopup} type="primary" >Ekle</Button>
            </div>
        </div>


        <div className={""}>
            <div className={"d-flex align-items-center w-100 header1"}>
                <div className={"col"}>
                    <p className={" h3 text-center"}> 5746 ARGE ESKİ HESAPLAMA</p>
                </div>
            </div>
            <div className={"row h5 nopadding header2"}>
                <div className={"col-1 border border-3 border-secondary"}>Dönem</div>
                <div className={"col-1 border border-3 border-secondary"}>Kanun</div>
                <div className={"col border border-3 border-secondary"}>Spek</div>
                <div className={"col border border-3 border-secondary"}>Tahakkuk</div>
                <div className={"col border border-3 border-secondary"}>İndirim</div>
                <div className={"col border border-3 border-secondary"}>5746 Spek İndirim</div>
            </div>
            <div className={"row nopadding valuesrow"}>
                <div className={"col-1 border border-3 border-secondary"}>2019/08</div>
                <div className={"col-1 border border-3 border-secondary"}>5746</div>
                <div className={"col border border-3 border-secondary"}>
                    <div className={"row w-100 h-100"}>
                        <div className={"col-9 w-100 h-100 bg-spek"}>{data.spek1} ₺</div>
                        <div className={"col-3"}>{format(data.spekOran1)}%</div>
                    </div>
                </div>
                <div className={"col border border-3 border-secondary"}>
                    <div className={"row w-100 h-100"}>
                        <div className={"col-9 w-100 h-100 bg-tahakkuk"}>{format(data.tahakkukTutar1)} ₺</div>
                        <div className={"col-3"}>{format(data.tahakkukOran1)}%</div>
                    </div>
                </div>
                <div className={"col border border-3 border-secondary"}>
                    <div className={"row w-100 h-100"}>
                        <div className={"col-9 bg-tahakkuk w-100 h-100"}>{format(data.indirimTutar1)} ₺</div>
                        <div className={"col-3"}>{format(data.indirimOran1)}%</div>
                    </div>
                </div>
                <div className={"col border border-3 border-secondary"}>{format(data.spekIndirim1)} ₺</div>
            </div>
        </div>


        <div className={"pl-4 pr-4 pb-4"}>
            <div className={"d-flex align-items-center w-100 header1"}>
                <div className={"col"}>
                    <p className={" h3 text-center"}> 5746 ARGE ESKİ HESAPLAMA</p>
                </div>
            </div>
            <div className={"row h5 nopadding header2"}>
                <div className={"col-1 border border-3 border-secondary"}>Dönem</div>
                <div className={"col-1 border border-3 border-secondary"}>Kanun</div>
                <div className={"col border border-3 border-secondary"}>Spek</div>
                <div className={"col border border-3 border-secondary"}>Tahakkuk</div>
                <div className={"col border border-3 border-secondary"}>İndirim</div>
                <div className={"col border border-3 border-secondary"}>5746 Spek İndirim</div>
            </div>
            <div className={"row nopadding valuesrow"}>
                <div className={"col-1 border border-3 border-secondary"}>2019/08</div>
                <div className={"col-1 border border-3 border-secondary"}>5746</div>
                <div className={"col border border-3 border-secondary"}>
                    <div className={"row w-100 h-100"}>
                        <div className={"col-9 w-100 h-100 bg-spek"}>{format(data.spek2)} ₺</div>
                        <div className={"col-3"}>{format(data.spekOran2)}%</div>
                    </div>
                </div>
                <div className={"col border border-3 border-secondary"}>
                    <div className={"row w-100 h-100"}>
                        <div className={"col-9 w-100 h-100 bg-tahakkuk"}>{format(data.tahakkukTutar2)} ₺</div>
                        <div className={"col-3"}>{format(data.tahakkukOran2)}%</div>
                    </div>
                </div>
                <div className={"col border border-3 border-secondary"}>
                    <div className={"row w-100 h-100"}>
                        <div className={"col-9 bg-tahakkuk w-100 h-100"}>{format(data.indirimTutar2)} ₺</div>
                        <div className={"col-3"}>{format(data.indirimOran2)}%</div>
                    </div>
                </div>
                <div className={"col border border-3 border-secondary"}>{format(data.spekIndirim2)} ₺</div>
            </div>
        </div>
        <div className={" pl-4 pr-4 pb-4 h5"}>
            <div className={"row bg-footer"}>
            <div className={"col"}>
            Aylık Yaklaşık Hesap : {format(data.sonuc)} ₺
            </div>
            <div className={"col"}>
                74 Aylık Yaklaşık Hesap : {format(data.sonucToplamAylik)} ₺
            </div>
                <div className={"col"}>
                    %20 : {format(data.sonucToplamAylik20)} ₺
                </div>
            </div>
        </div>


        {/*<Modal*/}
        {/*    maskClosable={false}*/}
        {/*    destroyOnClose*/}
        {/*    title={"Tutar"}*/}
        {/*    visible={popupState}*/}
        {/*    onOk={() => ekle(false)}*/}
        {/*    onCancel={popupClose}*/}
        {/*    okText={"Ekle"}*/}
        {/*    cancelText={"Vazgeç"}*/}
        {/*    okButtonProperties={{htmlType: "submit"}}*/}
        {/*>*/}
        {/*    <InputNumber*/}
        {/*        className={"w-100"}*/}
        {/*        formatter={value => `₺ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}*/}
        {/*        parser={value => value.replace(/\₺\s?|(,*)/g, '')}*/}
        {/*        value={data.ilaveTutar}*/}
        {/*        onChange={(value) => {*/}
        {/*            setData(Object.assign({}, data, {ilaveTutar: value}));*/}
        {/*        }}*/}
        {/*        placeholder="Tutar giriniz"*/}

        {/*    />*/}
        {/*</Modal>*/}
    </>;
}

export default YaklasikHesap;



